// the stat box Alpine object
window.appStat = (name, initialLabel, items) => {
    return {
        name,
        initialLabel,
        items,
        totalSelected: 0,
        label: '',
        expanded: false,

        init: function() {
            this.label = this.initialLabel;
            this.$nextTick(() => {
                this.items.forEach( item => {
                    if( this.isSelected(item.value) ) {
                        this.totalSelected++;
                    }
                });
            });
        },

        set: function(item) {
            // Already selected, then remove
            if( this.isSelected(item.value) ) {
                this.$store.stats = this.$store.stats.filter( v => v != item.value );
                this.$store.totalStats--;

            // otherwise add it if there is room
            } else {
                if( this.$store.totalStats < 8 ) {
                    this.$store.stats.push( item.value );
                    this.$store.totalStats++;
                }
            }
            // update the total selected
            this.totalSelected = 0;
            this.items.forEach( item => {
                if( this.isSelected(item.value) ) {
                    this.totalSelected++;
                }
            });
        },

        clearAll: function() {
            this.$store.stats = [];
            this.$store.totalStats = 0;
            this.totalSelected = 0;
            this.expanded = false;
        },

        isSelected: function( value ) {
            return this.$store.stats.findIndex((v,i) => v == value) !== -1;
        }
    }
};
